import { Component, type ReactNode } from "react";

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string }) {
    console.error("[ErrorBoundary] render crash:", error);
    if (info?.componentStack) console.error(info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="grid min-h-screen place-items-center bg-background p-6 text-foreground">
        <div className="max-w-xl space-y-4 rounded-lg border border-destructive/30 bg-card p-6">
          <h2 className="text-lg font-semibold text-destructive">
            渲染崩了
          </h2>
          <pre className="overflow-auto rounded bg-input p-3 font-mono text-xs leading-relaxed text-foreground/85">
            {this.state.error.message}
            {"\n\n"}
            {this.state.error.stack?.slice(0, 1200)}
          </pre>
          <button
            type="button"
            className="rounded-md border border-border bg-background px-4 py-2 text-sm hover:bg-white/5"
            onClick={() => {
              this.setState({ error: null });
              location.reload();
            }}
          >
            刷新页面
          </button>
        </div>
      </div>
    );
  }
}
